import usePageEditorStore from "@/components/PageEditor/store/usePageEditorStore";
import { Layers } from "@craftjs/layers";
import { faLayerGroup, faPencil } from "@fortawesome/sharp-regular-svg-icons";
import clsx from "clsx";
import { useState } from "react";
import LayerNode from "./components/LayerNode";
import Settings from "./components/Settings";
import SidebarItem from "./components/SidebarItem";

const Sidebar = () => {
    const [layersVisible, setLayerVisible] = useState<boolean>(true);
    const [toolbarVisible, setToolbarVisible] = useState<boolean>(true);

    const fullscreen = usePageEditorStore((state) => state.fullscreen);

    return (
        <div
            className={clsx([
                "min-w-[280px] w-[280px] bg-white ",
                fullscreen
                    ? "h-full"
                    : "min-h-[calc(100vh-70px-50px-150px-6px)] max-h-[calc(100vh-70px-50px-150px-6px)]",
            ])}
        >
            <div className="flex flex-col h-full max-h-full">
                <SidebarItem
                    icon={faPencil}
                    title="Customize"
                    height={!layersVisible ? "full" : "55%"}
                    visible={toolbarVisible}
                    onChange={(val) => setToolbarVisible(val)}
                >
                    <Settings />
                </SidebarItem>
                <SidebarItem
                    icon={faLayerGroup}
                    title="Layers"
                    height={!toolbarVisible ? "full" : "45%"}
                    visible={layersVisible}
                    onChange={(val) => setLayerVisible(val)}
                >
                    <Layers renderLayer={LayerNode} />
                </SidebarItem>
            </div>
        </div>
    );
};

export default Sidebar;
